module.exports = __webpack_public_path__ + "static/media/goodJob.b00b94b1.svg";